'use strict';

function NavLeftItemDirective () {

  var link = function ($scope, $el, attrs, ctrl, $transclude) {
    $el.addClass('sb-nav-left-item');

    // add transcluded elements
    $transclude(function (clone) {
      $el.append(clone);
    });
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    link: link,
    restrict: 'EA',
    scope: true,
    transclude: true
  };
}

module.exports = NavLeftItemDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/NavLeftItemDirective.js